export default {
  title: '场景',
  playTitle: '玩法模板',
  deleteSceneConfirm: '是否删除该场景?',
  deletePlaySceneConfirm: {
    title: '确认删除玩法模板吗？',
    rule1:
      '· 删除玩法模板，该玩法模板内绑定的场景会一并被删除。如希望保留场景内容，请先将场景与玩法模板进行解绑后再删除玩法模板。',
    rule2: '· 此操作不可恢复，请确认。',
    rule3: '· 删除最后一个玩法模板，将会自动返回项目编辑页。',
  },
  deleteSceneWarning: '警告',
  confirm: '确定',
  cancel: '取消',
  newScene: '新建场景',
  copyScene: '复制场景',
  renameScene: '重命名',
  deleteScene: '删除场景',
  newAndSave: '保存为预设',
  saveSuccess: '新建场景成功',
  deleteSceneError: '至少需要一个场景',
  newPlayScene: '新建玩法模板',
  deletePlayScene: '删除玩法模板',
}
